// Mock data for MBW Techimpex homepage

export const services = [
  {
    id: 10,
    title: "E-commerce Development",
    description: "High-performance, scalable online stores to boost your digital sales.",
    icon: "ShoppingCart",
    link: "e-commerce"
  },
  {
    id: 5,
    title: "Search Engine Optimization",
    description: "Improving SEO authority by earning high-quality, relevant backlinks from trusted industry and business websites.",
    icon: "Search",
    link: "digital-marketing"
  },
  {
    id: 3,
    title: "Website Development",
    description: "High-performance, custom websites that drive business growth.",
    icon: "Code",
    link: "website-development"
  },
  {
    id: 4,
    title: "Digital Marketing",
    description: "Grow your brand reach and visibility across digital channels.",
    icon: "TrendingUp",
    link: "digital-marketing"
  },
  {
    id: 9,
    title: "Mobile App Development",
    description: "Android & iOS apps that connect and engage your customers.",
    icon: "Smartphone",
    link: "mobile-app-development"
  },
  {
    id: 1,
    title: "Domain Name Registration",
    description: "Secure your digital identity with the perfect domain name for your business.",
    icon: "Globe",
    link: "domain-registration"
  },
  {
    id: 8,
    title: "Website & Domain Security",
    description: "Total protection for your digital assets with SSL and security tools.",
    icon: "Shield",
    link: "security"
  },
  {
    id: 2,
    title: "Web Hosting",
    description: "Fast, reliable, and scalable hosting solutions for your website.",
    icon: "Server",
    link: "web-hosting"
  },



  // {
  //   id: 6,
  //   title: "Social Media Marketing",
  //   description: "Engage and convert your target audience on social platforms.",
  //   icon: "Share2",
  //   link: "social-media"
  // },
  {
    id: 7,
    title: "Professional Business Emails",
    description: "Professional identity with secure, branded email solutions.",
    icon: "Mail",
    link: "professional-email"
  },
  {
    id: 11,
    title: "Database",
    description: "Enterprise-grade scalable databases and secure cloud storage.",
    icon: "Database",
    link: "cloud-storage-database"
  }
];

export const services_home = [
  {
    id: 1,
    title: "Domain Name Registration",
    description: "Secure your digital identity with the perfect domain name for your business.",
    icon: "Globe",
    link: "domain-registration"
  },
  {
    id: 2,
    title: "Web Hosting",
    description: "Fast, reliable, and scalable hosting solutions for your website.",
    icon: "Server",
    link: "web-hosting"
  },
  {
    id: 3,
    title: "Website Development",
    description: "High-performance, custom websites that drive business growth.",
    icon: "Code",
    link: "website-development"
  },
  {
    id: 4,
    title: "Digital Marketing",
    description: "Grow your brand reach and visibility across digital channels.",
    icon: "TrendingUp",
    link: "digital-marketing"
  },
  {
    id: 5,
    title: "Search Engine Optimization",
    description: "Improving SEO authority by earning high-quality, relevant backlinks from trusted industry and business websites.",
    icon: "Search",
    link: "digital-marketing"
  },
  {
    id: 6,
    title: "Social Media Marketing",
    description: "Engage and convert your target audience on social platforms.",
    icon: "Share2",
    link: "social-media"
  },
  {
    id: 7,
    title: "Professional Business Emails",
    description: "Professional identity with secure, branded email solutions.",
    icon: "Mail",
    link: "professional-email"
  },
  {
    id: 8,
    title: "Website & Domain Security",
    description: "Total protection for your digital assets with SSL and security tools.",
    icon: "Shield",
    link: "security"
  },
  {
    id: 9,
    title: "Mobile App Development",
    description: "Android & iOS apps that connect and engage your customers.",
    icon: "Smartphone",
    link: "mobile-app-development"
  },
  // {
  //   id: 11,
  //   title: "Cloud Storage & Database",
  //   description: "Enterprise-grade scalable databases and secure cloud storage.",
  //   icon: "Database",
  //   link: "cloud-storage-database"
  // }
  // {
  //   id: 10,
  //   title: "E-commerce Development",
  //   description: "High-performance, scalable online stores to boost your digital sales.",
  //   icon: "ShoppingCart",
  //   link: "e-commerce"
  // }
];

export const stats = [
  { label: "Clients", value: "4800+", icon: "Users" },
  { label: "Projects", value: "4500+", icon: "Briefcase" },
  { label: "Countries", value: "18", icon: "Globe" },
  { label: "Years Experience", value: "22+", icon: "Award" }
];

export const portfolioProjects = [
  {
    id: 1,
    title: "E-commerce Platform for Retail Brand",
    category: "Web Development",
    image: "/img/Home/Ecommerce.webp",
    description: "Complete e-commerce solution with payment gateway integration"
  },
  {
    id: 2,
    title: "Corporate Web Design",
    category: "Web Design",
    image: "/img/Home/office.webp",
    description: "Modern, responsive corporate website with CMS integration"
  },
  {
    id: 3,
    title: "Healthcare Mobile App",
    category: "Mobile Development",
    image: "/img/Home/mobile.webp",
    description: "Patient management app for healthcare providers"
  },
  {
    id: 4,
    title: "SEO Campaign for Startup / MSME's",
    category: "Digital Marketing",
    image: "/img/Home/SEO.webp",
    description: "Achieved 300% organic traffic growth in 6 months"
  },
  {
    id: 5,
    title: "Restaurant Booking Platform",
    category: "Web Development",
    image: "/img/Home/Restaurant.webp",
    description: "Online reservation system with table management"
  },
  {
    id: 6,
    title: "Manufacturing Company Portal",
    category: "Enterprise Solutions",
    image: "/img/Home/Manufacturing.webp",
    description: "B2B portal with inventory and order management"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Narendranath",
    position: "CEO",
    //company: "Executive Director",
    image: "/img/Home/9.webp",
    quote: "MBW has been associated with us for the past 6 years in providing end to end webpage development & maintenance solutions. They have also developed niche applications for our operational needs ."
  },
  {
    id: 2,
    name: "Vijay Vishwakarma",
    position: "IT HEAD - Bergner",
    //company: "Global Retail Inc",
    image: "/img/Home/9.webp",
    quote: "I am extremely proud of what we opted the services with MBW. Team made the process so smooth and good support. We keep coming back for the entire web & corporate mailing needs"
  },
  {
    id: 3,
    name: "V.P. Jayendhiran",
    position: "Asst. Manager IT - TVS Training & Services",
    //company: "StartupHub Asia",
    image: "/img/Home/9.webp",
    quote: "MBWIT is doing the wonderful design, economy and meets our expectation, Their attention to the projects is fabulous and their staffs response is really superb."
  },
  {
    id: 4,
    name: "George Thaliat",
    position: "World’s Leading Automobile Company",
    //company: "StartupHub Asia",
    image: "/img/Home/9.webp",
    quote: "We used MBW services for creation of multiple Webapps. During the course of activity we have received excellent support and response from MBW team for many last minute changes with on-time delivery."
  },
  {
    id: 5,
    name: "LS Transport , Canada",
    position: "Transportation Solutions in North America. ",
    //company: "StartupHub Asia",
    image: "/img/Home/9.webp",
    quote: "It was great effort from you providing all changes and updates in a timely manner, We will recommend your business! Keep in touch."
  },
  {
    id: 6,
    name: "AGS Health Care",
    position: "Medical & Healthcare backoffice Services ",
    //company: "StartupHub Asia",
    image: "/img/Home/9.webp",
    quote: "MBWIT is easy to work with. Mr. Sanjeevi & Srivatsan, you and your team are very supportive and willing to help us as your clients attain success!"
  },
  {
    id: 7,
    name: "Mr. Thirumeni",
    position: "DEBAJ Industrial Services, Qatar ",
    //company: "StartupHub Asia",
    image: "/img/Home/9.webp",
    quote: "Thank you for the web site modification task carried by your Team.  Our Company is satisfied with the overall performance on the task delivered with the outcome and the process."
  },
  {
    id: 8,
    name: "Vedant Dugar",
    position: "IT HEAD - Dugar",
    //company: "StartupHub Asia",
    image: "/img/Home/9.webp",
    quote: " great experience, the team was very helpful and help execute my vision for the website. "
  },

];

export const blogPosts = [
  {
    id: 1,
    title: "Top 10 SEO Trends for 2025",
    excerpt: "Discover the latest SEO strategies that will help your website rank higher in search results and attract more organic traffic.",
    image: "/img/Home/SEO_2025.webp",
    author: "Arun Prasad",
    date: "March 15, 2025",
    category: "SEO",
    readTime: "5 min read"
  },
  {
    id: 2,
    title: "Why Every Business Needs a Responsive Website",
    excerpt: "Learn why responsive web design is no longer optional and how it impacts your business growth and customer experience.",
    image: "/img/Home/web.webp",
    author: "Kavitha Reddy",
    date: "March 10, 2025",
    category: "Web Development",
    readTime: "4 min read"
  },
  {
    id: 3,
    title: "How Google Ads Can Drive 10X ROI",
    excerpt: "Explore proven strategies for creating high-converting Google Ads campaigns that deliver exceptional return on investment.",
    image: "/img/Home/ads.webp",
    author: "Sanjay Menon",
    date: "March 5, 2025",
    category: "Digital Marketing",
    readTime: "6 min read"
  }
];

export const processSteps = [
  {
    id: 1,
    title: "Discover",
    description: "We understand your business goals, target audience, and project requirements.",
    icon: "Lightbulb"
  },
  {
    id: 2,
    title: "Design",
    description: "Our designers create beautiful, user-friendly interfaces that reflect your brand.",
    icon: "Palette"
  },
  {
    id: 3,
    title: "Develop",
    description: "Expert developers build robust, scalable solutions using latest technologies.",
    icon: "Code2"
  },
  {
    id: 4,
    title: "Deliver",
    description: "We launch your project and provide ongoing support for continuous success.",
    icon: "Rocket"
  }
];

export const technologies = [
  { name: "React", icon: "react", description: "Modern UI Framework" },
  { name: "Node.js", icon: "nodejs", description: "Backend Runtime" },
  { name: "WordPress", icon: "wordpress", description: "CMS Platform" },
  { name: "Laravel", icon: "laravel", description: "PHP Framework" },
  { name: "Flutter", icon: "flutter", description: "Mobile Development" },
  { name: "Shopify", icon: "shopify", description: "E-commerce Platform" },
  { name: "AWS", icon: "aws", description: "Cloud Services" },
  { name: "Azure", icon: "azure", description: "Cloud Platform" },
  { name: "Google Ads", icon: "google", description: "PPC Advertising" },
  { name: "Meta Business", icon: "meta", description: "Social Media Ads" }
];

export const faqs = [
  {
    id: 1,
    question: "Do I need to know technical things to manage the website?",
    answer: "No. We provide simple tools and training so you can update your website easily without technical knowledge."
  },
  {
    id: 2,
    question: "Will my website be mobile-friendly?",
    answer: "Yes. Every website we build is fully responsive and works smoothly on phones, tablets, and desktops."
  },
  {
    id: 3,
    question: "What about domain and hosting?",
    answer: "We help you choose the best domain and hosting plan and set everything up for you completely."
  },
  {
    id: 4,
    question: "Can I update content myself later?",
    answer: "Yes. You will have access to edit text, images, pages, and media anytime."
  },
  {
    id: 5,
    question: "Will my website be secure?",
    answer: "Yes. We follow standard security practices, provide SSL, and can set up backups and maintenance."
  },
  {
    id: 6,
    question: "Can you redesign or improve my existing website?",
    answer: "Yes. We can refresh your UI, improve performance, and add new features to an existing website."
  },
  {
    id: 7,
    question: "What payment options are available?",
    answer: "We support bank transfer, UPI, online payment links, and invoice-based payments for businesses."
  }
];
